import React, { useState, useEffect, useRef } from "react";

import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  IconButton,
  CircularProgress,
  LinearProgress,
  FormControl,
  MenuItem,
  Select,
  Switch,
  Grid,
  Autocomplete,
} from "@mui/material";
import { styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { InputLabel, FormControlLabel, Checkbox } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReactQuill from "react-quill";

import { BASE_URL_TEST } from "../../../utils/baseUrl";
import { urls } from "../../../urls/urls";
import { useFetch, useFetchById, useUpdate, useDelete } from "../../../hooks";
import SnackbarComponent from "../../../components/SnackBar/snackBar";
import { useSelector } from "react-redux";
import imageCompression from "browser-image-compression";
import "react-quill/dist/quill.snow.css";
const BASE_IMAGE_URL = "https://heroelectroapi-production.up.railway.app";
const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const StyledPaper = styled(Paper)({
  padding: "16px",
  border: "1px solid #ddd",
  borderRadius: "4px",
  backgroundColor: "#fff",
});

const handleToggle = (setState) => () => {
  setState((prev) => !prev);
};

// Function to render buttons as ON/OFF
const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#52d869", // ON state color
        opacity: 1,
      },
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.5,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 13,
    backgroundColor: "#ccc", // OFF state color
    opacity: 1,
  },
}));

const ImageItem = ({ name, error, onRemove }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      p: 1,
      border: "1px solid #ddd",
      borderRadius: "4px",
    }}
  >
    <img
      src={name}
      alt="Product thumbnail"
      style={{
        width: "50px",
        height: "50px",
        marginRight: "8px",
        objectFit: "cover",
      }}
    />
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="body2" color="textSecondary">
        {name}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={100}
        sx={{
          height: "6px",
          borderRadius: "2px",
          mt: 1,
          backgroundColor: "inherit",
          "& .MuiLinearProgress-bar": {
            backgroundColor: error ? "red" : "green",
          },
        }}
      />
    </Box>

    <IconButton onClick={onRemove} sx={{ ml: 1 }}>
      <CloseIcon />
    </IconButton>
  </Box>
);

const closeIconStyle = {
  position: "absolute",
  top: 8,
  right: 8,
  zIndex: 10,
};

const Addbulkproducts = ({ onBack, setModalOpen, isEditing, menuData,isCustom,setCustomProduct }) => {
  const loginToken = useSelector((state) => state.user.logintoken);
  const appStateToken = useSelector((state) => state.user);

  console.log("menuDataEdit", menuData, isEditing,isCustom);

  const getInitialFormValues = () => ({
    category_id: isEditing ? menuData.category_id : "",
    vendor_id: isEditing ? menuData.vendor_id : "",
    vendor_product_id: isEditing ? menuData.vendor_product_id : "",
    sub_cat_id: isEditing ? menuData.sub_cat_id : "",
    subCategory_name: isEditing ? menuData.subCategory_name : "",
    product_id: isEditing ? menuData.product_id : "",
    product_name: isEditing ? menuData.product_name : "",
    vlisting_id: isEditing ? menuData.vlisting_id : "",
    brand_id: isEditing ? menuData.brand_id : 0,
    brand_name: isEditing ? menuData.brand_name : "",
    name: isEditing ? menuData.name : "",
    price: isEditing ? menuData.price : "",
    quantity: isEditing ? menuData.quantity : "",
    self_delivery: isEditing ? menuData.self_delivery : "0",
    self_pickup: isEditing ? menuData.self_pickup : "0",
    description: isEditing ? menuData.description : "",
    images: isEditing ? menuData.images : "",
    vendor: isEditing ? menuData.vendor : "",
    category_name: isEditing ? menuData.category_name : "",
    badge_id: isEditing ? menuData.badge_id : 0,
    badge_name: isEditing ? menuData.badge_name : "",
    ribbon_id: isEditing ? menuData.ribbon_id : 0,
    ribbon_name: isEditing ? menuData.ribbon_name : "",
    regularPrice: isEditing ? menuData.regularPrice : "0",
    salePrice: isEditing ? menuData.salePrice : "0",
    originalPrice: isEditing ? menuData.salePrice : "",
    variantData: isEditing ? menuData.variantData : "",
    status: isEditing ? menuData.status : "",
    name: isEditing ? menuData.name : "",
    product_description: isEditing ? menuData.product_description : "",
    tags: isEditing ? menuData.tags : "",
    sku: isEditing ? menuData.sku : "",
    discount: isEditing ? menuData.discount : "0",
    badge: isEditing ? menuData.badge : "",
    badge: isEditing ? menuData.badge : "",
    brnad: isEditing ? menuData.brnad : "",
    ribbon: isEditing ? menuData.ribbon : "",
    trashould_quantity: isEditing ? menuData.trashould_quantity : "0",
    stock_quantity: isEditing ? menuData.stock_quantity : "0",
    self_delivery: isEditing ? menuData.self_delivery : 0,
    self_pickup: isEditing ? menuData.self_pickup : 0,
    cod_allowed: isEditing ? menuData.cod_allowed : 0,
    is_retuanable: isEditing ? menuData.is_retuanable : 0,
    is_cancelable: isEditing ? menuData.is_cancelable : 0,
    images: isEditing ? menuData.images : [],
    image_ids: isEditing ? menuData.image_ids : "",
    badge_name: isEditing ? menuData.badge_name : "",
    description: isEditing ? menuData.description : "",
    status: isEditing ? menuData.status : 0,
  });
  const [variantSubCatData, setVariantSubCatData] = useState([]);
  const [formValues, setFormValues] = useState(getInitialFormValues());
  const [pRegularPriceError, setPRegularPriceError] = useState("");

  const [categoryNameError, setCategoryNameError] = useState("");
  const [subCategoryNameError, setSubCategoryNameError] = useState("");
  const [productNameError, setProductNameError] = useState(false);
  const [productDescError, setproductDescError] = useState(false);
  const [tagsError, setTagsError] = useState(false);
  const [skuError, setSKUError] = useState(false);
  const [regularPriceError, setRegularPriceError] = useState(false);
  const [salePriceError, setSalePriceError] = useState(false);
  const [discountError, setDiscountError] = useState(false);
  const [imagesError, setImagesError] = useState(false);
  const [stockQuantityError, setStockQuantityError] = useState(false);

  const { id } = useSelector((state) => state.user.userdetails);
  const [vendorCategoryNames, setVendorCatgoryNames] = useState([]);
  const [subCategoryNames, setSubCategoryNames] = useState([]);
  const [allVendorProdData, setAllVendorProductsData] = useState([]);
  const [productNames, setProductNames] = useState([]);
  const [regularPrices, setRegularPrice] = useState([]);
  const [productImages, setProductImages] = useState([]);
  const [productVariants, setProductVariants] = useState([]);
  const [variantOptionsResults, setVariantOptionsResult] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const imageInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [selfDelivery, setSelfDelivery] = useState(false);
  const [selfPickup, setSelfPickup] = useState(false);
  const [codAllowed, setCodAllowed] = useState(false);
  const [isReturnable, setIsReturnable] = useState(false);
  const [isCancelable, setIsCancelable] = useState(false);
  const [attachmentRequired, setAttachmentRequired] = useState(false);
  const [mode, setMode] = useState("select"); 

  const [selectedProduct, setSelectedProduct] = useState("");
  const [ribbon, setRibbon] = useState([]);
  const [badge, setBadge] = useState([]);
  const [brands, setBrands] = useState([]);
  const [deletingImageId, setDeletinImageId] = useState();

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success", // Default severity
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });

  const handleRemoveImage = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleFileChange = (event) => {
    // const files = event.target.files;
    // const validFiles = [];
    // const errors = [];

    // if (files) {
    //   if (selectedFiles.length + files.length > 4) {
    //     setErrorMessage("You can only upload up to 3 images.");
    //     return;
    //   }

    //   Array.from(files).forEach((file) => {
    //     if (file.type === "image/jpeg" || file.type === "image/png") {
    //       validFiles.push(file);
    //     } else {
    //       errors.push(
    //         `${file.name} is not a valid image. Only .jpg and .png are allowed.`
    //       );
    //     }
    //   });

    //   if (errors.length > 0) {
    //     setErrorMessage(errors.join(", "));
    //   } else {
    //     setErrorMessage(null);
    //   }

    //   setSelectedFiles((prev) => [...prev, ...validFiles]);
    // }

    const files = event.target.files;
    const validFiles = [];
    const errors = [];

    if (!files) return;

    // if (files) {
    //   if (selectedFiles.length + files.length > 4) {
    //     setErrorMessage("You can only upload up to 4 images.");
    //     return;
    //   }

    //   Array.from(files).forEach((file) => {
    //     if (file.type === "image/jpeg" || file.type === "image/png") {
    //       validFiles.push(file);
    //     } else {
    //       errors.push(
    //         "${file.name} is not a valid image. Only .jpg and .png are allowed."
    //       );
    //     }
    //   });

    //   if (errors.length > 0) {
    //     setErrorMessage(errors.join(", "));
    //   } else {
    //     setErrorMessage(null);
    //   }

    //   setSelectedFiles((prev) => [...prev, ...validFiles]);
    // }
    const totalSelected = selectedFiles.length + selectedImageIds.length;
    if (totalSelected + files.length > 3) {
      setErrorMessage("You can select only 3 images total.");
      return;
    }

    Array.from(files).forEach((file) => {
      if (file.type === "image/jpeg" || file.type === "image/png") {
        validFiles.push(file);
      } else {
        setErrorMessage(`${file.name} invalid (only jpg, png allowed)`);
      }
    });

    setSelectedFiles((prev) => [...prev, ...validFiles]);
  };

  const handleClickrest = () => {
    alert("Reset Succesfull!");
  };

  const handleClickproduct = async () => {
    // alert("Added Succesfully!");
    console.log(
      "formValuesselectedOptions",
      formValues["product_name"],
      "prdid",
      formValues["product_id"]
    );
    console.log("formValuesselectedOptions", menuData);
    // console.log("formValuesselectedOptions",formValues['image_ids'].length);
    if (formValues) {
      if (!formValues["category_id"]) {
        setCategoryNameError("Category name is required");
        return;
      }

      if (!formValues["sub_cat_id"]) {
        setSubCategoryNameError("Sub Category name is required");
        return;
      }
      if (!isEditing && !formValues["product_name"]) {
        setProductNameError(true);
        return;
      } else {
        setProductNameError(false);
      }
      if (!formValues["product_description"]) {
        setproductDescError(true);
        return;
      }
      setproductDescError(false);

      // if (!formValues["tags"]) {
      //   setTagsError(true);
      //   return;
      // } else {
      //   setTagsError(false);
      // }
      if (!formValues["sku"]) {
        setSKUError(true);
        return;
      }
      if (!formValues["regularPrice"]) {
        setRegularPriceError(true);
        return;
      }
      // if (!formValues["salePrice"]) {
      //   setSalePriceError(true);
      //   return;
      // }
      // if (!formValues["discount"]) {
      //   setDiscountError(true);
      //   return;
      // }

      setDiscountError(false);
      console.log("image_ids:selectedImageIds", selectedImageIds);
      console.log("image_ids:selectedFiles", selectedFiles);
      const totalImages = selectedImageIds.length + selectedFiles.length;
      console.log("formValuesselectedOptions totalImages count",totalImages,formValues);
      if (totalImages > 3) {
        console.log(
          "formValuesselectedOptions im",
          selectedImageIds,
          selectedFiles
        );
        setImagesError(true);
        return;
      } else if (totalImages < 3) {
        setImagesError(true);
        return;
      }
      setImagesError(false);

      if (!isEditing) {
         console.log("Custom Product 408",formValues);
        if (formValues["self_pickup"] || formValues["self_delivery"]) {
          const formdata = new FormData();
          console.log("Custom Product 411",formValues,formValues["category_id"],formValues["sub_cat_id"],formValues["product_id"]);
          formdata.append("category_id", formValues["category_id"]);
          formdata.append("sub_cat_id", formValues["sub_cat_id"]);
          formdata.append("product_id", isCustom? 0 : formValues["product_id"]);
          formdata.append(
            "product_description",
            formValues["product_description"]
          );
          formdata.append("tags", formValues["tags"]);
          formdata.append("sku", formValues["sku"]);
          formdata.append("regularPrice", formValues["regularPrice"]);
          formdata.append("salePrice", formValues["salePrice"]);
          formdata.append("discount", formValues["discount"]);
          formdata.append("stock_quantity", formValues["stock_quantity"]);
          formdata.append(
            "trashould_quantity",
            formValues["trashould_quantity"]
          );
          formdata.append("self_delivery", formValues["self_delivery"]);
          formdata.append("cod_allowed", formValues["cod_allowed"]);
          formdata.append("is_retuanable", formValues["is_retuanable"]);
          formdata.append("is_cancelable", formValues["is_cancelable"]);
          formdata.append("description", formValues["description"]);
          formdata.append(
            "variantData",
            selectedOptions ? JSON.stringify(selectedOptions) : ""
          );
          formdata.append("product_image_ids", isCustom?"" : formValues["image_ids"]);
          // formdata.append("images",selectedFiles);
          for (const file of selectedFiles) {
            const compressedFile = await compressImage(file);
            formdata.append("images", compressedFile);
          }
          formdata.append("vendor_id", id);
          formdata.append("brand_id", formValues["brand_id"]);
          formdata.append("badge_id", formValues["badge_id"]);
          formdata.append("ribbon_id", formValues["ribbon_id"]);
          formdata.append("product_name", formValues["product_name"]);
          console.log("Custom Product",formdata);
          fetchCreateProduct(formdata);
        } else {
          setShowSwitchError(true);
        }
      } else {
        const updateUrl = urls(
          "updateVProductsById",
          formValues["vendor_product_id"]
        );
        console.log("upodate imgeids", formValues["image_ids"]);
        if (formValues["self_pickup"] || formValues["self_delivery"]) {
          const formdata = new FormData();
          formdata.append("category_id", formValues["category_id"]);
          formdata.append("sub_cat_id", formValues["sub_cat_id"]);
          formdata.append(
            "product_id",
            formValues["product_id"] || menuData["product_id"]
          );
          formdata.append(
            "product_description",
            formValues["product_description"]
          );
          formdata.append("tags", formValues["tags"]);
          formdata.append("sku", formValues["sku"]);
          formdata.append("regularPrice", formValues["regularPrice"]);
          formdata.append("salePrice", formValues["salePrice"]);
          formdata.append("discount", formValues["discount"]);
          formdata.append("stock_quantity", formValues["stock_quantity"]);
          formdata.append(
            "trashould_quantity",
            formValues["trashould_quantity"]
          );
          formdata.append("self_delivery", formValues["self_delivery"]);
          formdata.append("cod_allowed", formValues["cod_allowed"]);
          formdata.append("is_retuanable", formValues["is_retuanable"]);
          formdata.append("is_cancelable", formValues["is_cancelable"]);
          formdata.append("description", formValues["description"]);
          //formdata.append("variantData", selectedOptions);
          formdata.append(
            "variantData",
            selectedOptions ? JSON.stringify(selectedOptions) : ""
          );
          formdata.append("product_image_ids", formValues["image_ids"]);
          // formdata.append("images",selectedFiles);
          for (const file of selectedFiles) {
            const compressedFile = await compressImage(file);
            formdata.append("images", compressedFile);
          }
          formdata.append("vendor_id", id);
          formdata.append(
            "product_name",
            formValues["product_name"] || menuData["product_name"]
          );
          formdata.append("status", formValues.status);
          fetchUpdateData(updateUrl, formdata);
        } else {
          setShowSwitchError(true);
        }
      }
      
    }
  };

  const [showSwitchError, setShowSwitchError] = useState(false);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [selectedImageIds, setSelectedImageIds] = useState([]);

  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    try {
      return await imageCompression(file, options);
    } catch (error) {
      console.error("Error compressing image:", error);
      return file;
    }
  };

  useEffect(() => {
    fetchData();
    fetchBrandData();
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  const handleImageClick = () => {
    imageInputRef.current?.click();
  };

  useEffect(() => {
    // const formdata = new FormData();
    // formdata.append("vendor_id", appStateToken.userdetails.id);
    vendorCategoryFetchData({ vendor_id: appStateToken.userdetails.id });
  }, [appStateToken.userdetails.id]);

  const {
    data: productData,
    error: productDataError,
    fetchData: fetchCreateProduct,
  } = useFetch(BASE_URL_TEST + urls("createVProducts"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: ribbonData,
    isLoading: isBadgeLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllRibbons"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: brandsData,
    isLoading: isBrandsLoading,
    error: brandsDataError,
    fetchData: fetchBrandData,
  } = useFetch(BASE_URL_TEST + urls("getAllBrands"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: vendorCategoryData,
    error: vendorCategoryError,
    isLoading: vendorCategoryLoading,
    fetchData: vendorCategoryFetchData,
  } = useFetch(BASE_URL_TEST + urls("getVCategories"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: subCategoryData,
    error: subCategoryError,
    fetchDataById: fetchSubCategory,
  } = useFetchById(BASE_URL_TEST, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: vendorProductsData,
    error: vendorProductsError,
    isLoading: vendorProductsLoading,
    fetchData: vendorProductsFetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllVProductsNames"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: vProductIdData,
    error: vProductIdError,
    fetchDataById: fetchVProductsByID,
  } = useFetchById(BASE_URL_TEST, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updatedProductData,
    error: updatedProductError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  // Image delet by ID vendor
  const {
    data: deleteImageData,
    isLoading: deleteImageLoading,
    error: deleteImageError,
    deleteData: fetchDeleteImageData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (deleteImageError) {
    } else if (deleteImageData && deleteImageData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: deleteImageData["message"],
        status: deleteImageData["status"],
      });
      setUploadedImages((prev) =>
        prev.filter((img) => getImageId(img) !== deletingImageId)
      );

      setFormValues((prev) => ({
        ...prev,
        images: prev.images.filter(
          (img) => getImageId(img) !== deletingImageId
        ),
      }));

      // Also update selectedImageIds if needed
      setSelectedImageIds((prev) =>
        prev.filter((id) => id !== deletingImageId)
      );
      // setDeleteModalOpen(true);
      // fetchData();
      //  setSelectedFiles([])
    } else if (deleteImageData && deleteImageData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: deleteImageData["message"],
        status: deleteImageData["status"],
      });
      // setDeleteModalOpen(true);
      // fetchData();
    }
  }, [deleteImageData, deleteImageError]);

  // Ribbon

  useEffect(() => {
    if (error) {
    } else if (ribbonData && ribbonData["status"] === true) {
      // console.log("ribbonDataBadge",ribbonData['data'])
      // setRows(ribbonData['data'])
      const ribbonOnly = ribbonData["data"].filter(
        (item) => item.type === "ribbon"
      );
      const badgeOnly = ribbonData["data"].filter(
        (item) => item.type === "badge"
      );
      setRibbon(ribbonOnly);

      setBadge(badgeOnly);
      console.log("ribbonOnly", ribbonOnly);
      console.log("badgeOnly", badgeOnly);
    }
  }, [ribbonData, error]);

  // Brand
  useEffect(() => {
    if (error) {
    } else if (brandsData && brandsData["status"] === true) {
      // console.log("ribbonDataBadge",ribbonData['data'])
      // setRows(ribbonData['data'])
      // const ribbonOnly = brandsData["data"].filter(
      //   (item) => item.type === "badge"
      // );
      setBrands(brandsData["data"]);
    }
  }, [brandsData, error]);

  useEffect(() => {
    if (formValues["category_id"]) {
      const catByIdUrl = urls("findByCatId", formValues["category_id"]);

      fetchSubCategory(catByIdUrl);
      //   vendorProductsFetchData({
      //     "category_id": "6",
      //     "sub_cat_id": "6"
      // })
    }
  }, [formValues["category_id"]]);

  useEffect(() => {
    if(!isEditing){
      if (formValues["category_id"] && formValues["sub_cat_id"]) {
        vendorProductsFetchData({
          category_id: formValues["category_id"],
          sub_cat_id: formValues["sub_cat_id"],
        });
        // Reset mode to dropdown when subcategory changes
        setMode("select");
      }
    }
  }, [formValues["category_id"], formValues["sub_cat_id"], isEditing]);

  useEffect(() => {
    console.log("productData", productData);
    if (productDataError) {
      console.log("productDataError", productDataError);
    } else if (productData && productData["status"] == true) {
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: productData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
    } else if (productData && productData["status"] == false) {
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: productData["message"],
        position: { vertical: "bottom", horizontal: "right" },
        severity: "error",
      });
    }
  }, [productData, productDataError]);

  // useEffect(() => {
  //   if (vendorProductsError) {
  //   } else if (vendorProductsData && vendorProductsData.status == true) {
  //     setAllVendorProductsData(vendorProductsData["data"]);
  //     const formattedProducts = allVendorProdData&&allVendorProdData.map((item, index) =>

  //     item.name

  //   );

  //     setProductNames(formattedProducts);

  //     const filteredProdVariants=allVendorProdData && allVendorProdData.map((item,index)=>item.variantData );
  //     console.log("productNames",formattedProducts)
  //     setProductVariants(filteredProdVariants)

  //   }
  // }, [vendorProductsData, vendorProductsError]);

  useEffect(() => {
    if (updatedProductError) {
    } else if (updatedProductData) {
      if (updatedProductData && updatedProductData["status"] === true) {
        setSnackbarState({
          ...snackbarState,
          open: true,
          message: updatedProductData["message"],
          position: { vertical: "top", horizontal: "center" },
          severity: "success",
        });
        setModalOpen(false);
      } else if (updatedProductData && updatedProductData["status"] == false) {
        setSnackbarState({
          ...snackbarState,
          open: true,
          message: updatedProductData["message"],
          position: { vertical: "bottom", horizontal: "right" },
          severity: "error",
        });
      }
    }
  }, [updatedProductData, updatedProductError]);

  useEffect(() => {
      setProductNames([]);
    if (vendorProductsError) {
      // Handle error here if needed
    } else if (vendorProductsData && vendorProductsData.status === true) {
      const freshData = vendorProductsData.data;
      console.log("vendorProductsData", freshData);
      setProductNames(freshData);
    }
  }, [vendorProductsData, vendorProductsError]);

  // console.log("filteredProdVariants",productVariants)

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  useEffect(() => {
    if (vendorCategoryError) {
    } else if (vendorCategoryData && vendorCategoryData.status == true) {
    
      setVendorCatgoryNames(vendorCategoryData["data"]);
    }
  }, [vendorCategoryData, vendorCategoryError]);

  useEffect(() => {
    if (subCategoryError) {
    } else if (subCategoryData && subCategoryData.status == true) {
      if (!isEditing) {
        setFormValues({...formValues, product_name:'', product_id:''});
        setMode("select"); // Reset to dropdown mode when subcategory changes
      }
      setSubCategoryNames(subCategoryData["data"]);
    }
  }, [subCategoryData, subCategoryError]);

  // useEffect(() => {
  //   console.log("useEffectcalled", menuData, isEditing);
  //   if (isEditing) {
  //     const formattedImages = menuData["images"];
  //     setUploadedImages(formattedImages);
  //     setSelectedImageIds(formattedImages.map((img) => img.vp_image_id));
      
  //     // Initialize selectedOptions with variantData from menuData
  //     if (menuData["variantData"] && menuData["variantData"].length > 0) {
  //       setSelectedOptions(menuData["variantData"]);
  //       console.log("Initialized selectedOptions with menuData variants:", menuData["variantData"]);
  //     }
      
  //     // Fetch variants for editing based on menuData's sub_cat_id
  //     if (menuData["sub_cat_id"]) {
  //       const subCatByVIdUrl = urls(
  //         "getVariantBySubCatID",
  //         menuData["sub_cat_id"]
  //       );
  //       console.log("Fetching variants for edit mode with sub_cat_id:", menuData["sub_cat_id"]);
  //       fetchVarinatIdSubCategory(subCatByVIdUrl);
  //     }
  //   }
  //   setFormValues({ ...formValues, image_ids: selectedImageIds });
  //   console.log(
  //     "useEffect selecttedImgid",
  //     selectedImageIds,
  //     formValues["image_ids"]
  //   );
  // }, [menuData]);


  useEffect(() => {
  console.log("useEffect called", menuData, isEditing);

  if (isEditing) {
    initializeEditData(menuData);
  }
}, [menuData, isEditing]);

  const initializeEditData = (data) => {
  if (!data) return;

  const formattedImages = data.images || [];
  setUploadedImages(formattedImages);

  const imageIds = formattedImages.map((img) => img.vp_image_id);
  setSelectedImageIds(imageIds);

  setFormValues((prev) => ({
    ...prev,
    image_ids: imageIds,
  }));

  // Initialize selectedOptions
  if (data.variantData && data.variantData.length > 0) {
    setSelectedOptions(data.variantData);
    console.log("Initialized selectedOptions:", data.variantData);
  }

  // Fetch variants
  if (data.sub_cat_id) {
    const subCatByVIdUrl = urls("getVariantBySubCatID", data.sub_cat_id);
    console.log("Fetching variants with sub_cat_id:", data.sub_cat_id);
    fetchVarinatIdSubCategory(subCatByVIdUrl);
  }
};

  // useEffect(() => {
  //   if (vProductIdError) {
  //   }
  //   else if (vProductIdData && vProductIdData.status == true)
  //      {
  //     const freshData = vProductIdData.data;

  //     console.log("objectfd",freshData['variantData'])

  //     var formattedImages='';
  //     if(isEditing)
  //     {
  //         formattedImages=menuData&&menuData['images']
  //          setSelectedImageIds(formattedImages.map(img => img.vp_image_id));
  //     }
  //     else
  //     {
  //  formattedImages = freshData['images']

  //     setUploadedImages(formattedImages);
  //      setSelectedImageIds(formattedImages.map(img => img.p_image_id));
  //      console.log("selectedimgidd usef",selectedImageIds)
  //     setFormValues({...formValues,images:formattedImages,regularPrice:freshData['regular_price'],salePrice:freshData['salePrice']})

  //     const filteredProdVariants=freshData['variantData']
  //       setProductVariants(filteredProdVariants);

  //     console.log("productImages", freshData);
  //     console.log("filteredProdVariants", filteredProdVariants);

  //     // processVariants()
  //   }
  // }}, [vProductIdData, vProductIdError]);

  const getImageId = (img) => img.vp_image_id || img.p_image_id;
  useEffect(() => {
    if (vProductIdError) return;

    if (vProductIdData && vProductIdData.status === true) {
      const freshData = vProductIdData.data;

      let formattedImages = [];

      console.log("freshData  IDs:", freshData);

      if (freshData.images && freshData.images.length > 0) {
        formattedImages = freshData.images;
      } else if (isEditing && menuData && menuData.images) {
        formattedImages = menuData.images;
      }

      const imageIds = formattedImages.map(
        (img) => img.vp_image_id || img.p_image_id
      );

      setUploadedImages(formattedImages);
      setSelectedImageIds(imageIds);

      setFormValues((prev) => ({
        ...prev,
        images: formattedImages,
        regularPrice: freshData.regular_price,
        salePrice: freshData.salePrice,
        originalPrice: freshData.salePrice,
      }));

      setProductVariants(freshData.variantData || []);

      console.log("Updated image IDs:", imageIds);
      console.log("New product images:", formattedImages);
    }
  }, [vProductIdData, vProductIdError, isEditing, menuData]);

  useEffect(() => {
    if (formValues["product_id"] && !isEditing) {
      const vProductIdUrl = urls("getVProductsById", formValues["product_id"]);
      fetchVProductsByID(vProductIdUrl);
    }
  }, [formValues["product_id"]]);

  useEffect(() => {
    const subCatByVIdUrl = urls(
      "getVariantBySubCatID",
      formValues["sub_cat_id"]
    );
    console.log("subCatByVIdUrl", subCatByVIdUrl);
    console.log("subCatByVIdUrl", formValues["subcategory"]);
    // Fetch variants for both create and edit modes
    if (formValues["sub_cat_id"] && (isEditing || !isEditing)) {
      fetchVarinatIdSubCategory(subCatByVIdUrl);
    }
  }, [formValues["sub_cat_id"], isEditing]);

  // Variant BySubCat ID
  const {
    data: varinatIdSubCategoryData,
    error: varinatIdSubCategoryError,
    fetchDataById: fetchVarinatIdSubCategory,
  } = useFetchById(BASE_URL_TEST, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (varinatIdSubCategoryError) {
    } else if (
      varinatIdSubCategoryData &&
      varinatIdSubCategoryData["status"] === true
    ) {
      console.log(
        "varinatIdSubCategoryData product",
        varinatIdSubCategoryData["data"]
      );

      setVariantSubCatData(varinatIdSubCategoryData["data"]);
    }
  }, [varinatIdSubCategoryData, varinatIdSubCategoryError]);

  const handleCheckboxChange = (variantName, optionName, item) => {
    console.log("Checkbox clicked:", { variantName, optionName, item });
    console.log("Current selectedOptions before change:", selectedOptions);

    if (!item || !item.options) {
      console.error("Invalid item or missing options:", item);
      return;
    }

    const selectedOptionDetails = item.options.find(
      (option) => option.option_name === optionName
    );

    if (!selectedOptionDetails) {
      console.error(`Option "${optionName}" not found in item:`, item);
      return;
    }

    setSelectedOptions((prevState) => {
      const newState = JSON.parse(JSON.stringify(prevState || []));
      console.log("Previous state in setter:", newState);

      const variantIndex = newState.findIndex(
        (variant) => variant.variant_id === item.variant_id
      );

      console.log("Previous state in setter variantIndex:", variantIndex);
      let updatedState;
      if (variantIndex === -1) {
        updatedState = [
          ...newState,
          {
            variant_id: item.variant_id,
            title: variantName,
            options: [
              {
                variant_option_id: selectedOptionDetails.variant_option_id,
                option_name: optionName,
              },
            ],
          },
        ];
      } else {
        const existingOptionIndex = newState[variantIndex].options.findIndex(
          (option) =>
            option.variant_option_id === selectedOptionDetails.variant_option_id
        );

        if (existingOptionIndex === -1) {
          newState[variantIndex].options.push({
            variant_option_id: selectedOptionDetails.variant_option_id,
            option_name: optionName,
          });
        } else {
          newState[variantIndex].options.splice(existingOptionIndex, 1);
          if (newState[variantIndex].options.length === 0) {
            newState.splice(variantIndex, 1);
          }
        }
        updatedState = newState;
      }

      console.log("Updated state after change:", updatedState);
      return updatedState;
    });

    console.log("selectedOptions", selectedOptions);

    setTimeout(() => {
      console.log("selectedOptions after update:", selectedOptions);
    }, 0);
  };

 

  useEffect(() => {
    // Process variants for both create and edit modes
    // In edit mode: variant data comes from menuData and is combined with fetched options
    // In create mode: variant data comes from selected category/subcategory
    if (variantSubCatData && variantSubCatData.length > 0) {
      processVariants();
    }
  }, [variantSubCatData, isEditing, selectedOptions,isCustom]);

  // function renderVariantOptions() {
  //   console.log("variantOptionsResults",variantOptionsResults)
  //             if (!variantOptionsResults || variantOptionsResults.length === 0) {
  //               return <Typography>No variant options available</Typography>;
  //             }

  //             return variantOptionsResults.map(item => (
  //               <div key={item.variant_id} className="variant-group">
  //                 <Typography variant="h6">{item.variant_name}</Typography>

  //                 {item.options.length > 0 ? (
  //                   item.options.map((option) => {
  //                     // Find if this variant exists in our selected options
  //                     const selectedVariant = selectedOptions.find(
  //                       variant => variant.variant_id === item.variant_id
  //                     );

  //                     // Check if this specific option is selected
  //                     const isSelected = selectedVariant?.options.some(
  //                       selected => selected.variant_option_id === option.variant_option_id
  //                     );

  //                     return (
  //                       <FormControlLabel
  //                         key={option.variant_option_id}
  //                         control={
  //                           <Checkbox
  //                             checked={isSelected || false}
  //                             onChange={() => handleCheckboxChange(item.variant_name, option.option_name, item)}
  //                           />
  //                         }
  //                         label={option.option_name}
  //                       />
  //                     );
  //                   })
  //                 ) : (
  //                   <Typography variant="body2" color="text.secondary">
  //                     No options available
  //                   </Typography>
  //                 )}
  //               </div>
  //             ));
  //           }

  function renderVariantOptions() {
    // if (!variantOptionsResults || variantOptionsResults.length === 0) {
    //   return <Typography>No variant options available</Typography>;
    // }
    console.log("enderoptins", menuData, "selectedOptions", selectedOptions);
    if (isEditing) {
      // In edit mode, show all options from API (variantOptionsResults)
      // and mark selections using selectedOptions (initialized from menuData)
      return variantOptionsResults && variantOptionsResults.length > 0
        ? variantOptionsResults.map((item) => (
            <div key={item.variant_id} className="variant-group">
              <Typography variant="h6">{item.title || item.variant_name}</Typography>

              {item.options && item.options.length > 0 ? (
                item.options.map((option) => {
                  const selectedVariant = selectedOptions.find(
                    (variant) => variant.variant_id === item.variant_id
                  );

                  const isSelected = selectedVariant?.options.some(
                    (selected) =>
                      selected.variant_option_id === option.variant_option_id
                  );

                  return (
                    <FormControlLabel
                      key={option.variant_option_id}
                      control={
                        <Checkbox
                          checked={isSelected || false}
                          onChange={() =>
                            handleCheckboxChange(
                              item.title || item.variant_name,
                              option.option_name,
                              item
                            )
                          }
                        />
                      }
                      label={option.option_name}
                    />
                  );
                })
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No options
                </Typography>
              )}
            </div>
          ))
        : "";
    } else {
      return variantOptionsResults.map((item) => (
        <div key={item.variant_id} className="variant-group">
          <Typography variant="h6">{item.variant_name}</Typography>

          {item.options.length > 0 ? (
            item.options.map((option) => {
              // Find if this variant exists in our selected options
              const selectedVariant = selectedOptions.find(
                (variant) => variant.variant_id === item.variant_id
              );

              // Check if this specific option is selected
              const isSelected = selectedVariant?.options.some(
                (selected) =>
                  selected.variant_option_id === option.variant_option_id
              );

              return (
                <FormControlLabel
                  key={option.variant_option_id}
                  control={
                    <Checkbox
                      checked={isSelected || false}
                      onChange={() =>
                        handleCheckboxChange(
                          item.variant_name,
                          option.option_name,
                          item
                        )
                      }
                    />
                  }
                  label={option.option_name}
                />
              );
            })
          ) : (
            <Typography variant="body2" color="text.secondary">
              No options available
            </Typography>
          )}
        </div>
      ));
    }
  }

  //   async function processVariants() {
  //     console.log("procesV",productVariants )
  //     const results = [];
  //     for (const variant of productVariants) {
  //         try {
  //             // const options = await fetchVariantOptions(variant.variant_id);
  //             console.log("variantNam",variant)
  //             results.push({
  //                 variant_name: variant.title,
  //                 // variant_id: variant.variant_id,
  //                 options: variant.options.map(option => ({
  //                     variant_option_id: option?.variant_option_id,
  //                     option_name: option?.option_name,
  //                     status: option?.status,
  //                     variant_id: option?.variant_id,
  //                     variant_name: option?.variant_name
  //                 }))
  //             });
  //         } catch (error) {
  //             console.error(`Failed to fetch data for variant_id ${variant.variant_id}:`, error);
  //         }
  //     }

  //     console.log("results", results);
  //     setVariantOptionsResult(results);
  // }

  //   async function processVariants() {
  //     console.log("procesV", productVariants);
  //     const variantMap = new Map();

  //     for (const variant of productVariants) {
  //       try {
  //         const variantName = variant.title;

  //         if (!variantMap.has(variantName)) {
  //           variantMap.set(variantName, {
  //             variant_name: variantName,
  //             variant_id: variant.variant_id,
  //             options: [],
  //           });
  //         }

  //         const existingVariant = variantMap.get(variantName);

  //         variant.options?.forEach((option) => {
  //           const optionExists = existingVariant.options.some(
  //             (existingOption) => existingOption.variant_option_id === option.variant_option_id
  //           );

  //           if (!optionExists) {
  //             existingVariant.options.push({
  //               variant_option_id: option.variant_option_id,
  //               option_name: option.option_name,
  //               status: option?.status,
  //               variant_id: option?.variant_id || variant.variant_id,
  //               variant_name: option?.variant_name || variant.title,
  //             });
  //           }
  //         });
  //       } catch (error) {
  //         console.error("Failed to process variant:", error);
  //       }
  //     }

  //     const results = Array.from(variantMap.values());
  //     console.log("results", results);
  //     setVariantOptionsResult(results);
  // }

  async function processVariants() {
    console.log("processVariants called - isEditing:", isEditing);
    
    if (isEditing && menuData?.variantData) {
      // For editing: process variants from menuData and variantSubCatData
      return processEditVariants();
    }
    
    // For creating: process variants from variantSubCatData
    console.log("Processing new product variants", variantSubCatData);
    
    if (!variantSubCatData || variantSubCatData.length === 0) {
      console.log("No variant subcategory data available");
      setVariantOptionsResult([]);
      return;
    }
    
    try {
      // Fetch all variant options and group by variant
      const allOptions = [];
      for (const variant of variantSubCatData) {
        const options = await fetchVariantOptions(variant.variant_id);
        allOptions.push(...options);
      }
      
      // Club/Group options by variant_id and variant_name
      const groupedVariants = groupVariantOptions(allOptions);
      
      console.log("New product variant results (grouped)", groupedVariants);
      setVariantOptionsResult(groupedVariants);
    } catch (error) {
      console.error("Error processing variants:", error);
      setVariantOptionsResult([]);
    }
  }

  async function processEditVariants() {
    // For editing: combine variantSubCatData with menuData.variantData
    console.log("Processing edit product variants", {
      variantSubCatData,
      menuDataVariants: menuData?.variantData,
    });

    if (!variantSubCatData || variantSubCatData.length === 0) {
      // Fallback: use menuData variants if no subcategory data
      if (menuData?.variantData && Array.isArray(menuData.variantData)) {
        setVariantOptionsResult(menuData.variantData);
        console.log("Using menuData variants as fallback");
      }
      return;
    }

    try {
      // Fetch all variant options from API
      const allOptions = [];
      for (const variant of variantSubCatData) {
        const options = await fetchVariantOptions(variant.variant_id);
        allOptions.push(...options);
      }
      
      // Club/Group options by variant_id and variant_name
      const groupedVariants = groupVariantOptions(allOptions);

      // Merge any options present only in menuData.variantData
      const groupedMap = new Map(groupedVariants.map(v => [v.variant_id, v]));
      if (menuData?.variantData && Array.isArray(menuData.variantData)) {
        menuData.variantData.forEach(mdVar => {
          const existing = groupedMap.get(mdVar.variant_id);
          if (!existing) {
            groupedMap.set(mdVar.variant_id, {
              variant_id: mdVar.variant_id,
              variant_name: mdVar.title,
              title: mdVar.title,
              options: mdVar.options.map(o => ({
                variant_option_id: o.variant_option_id,
                option_name: o.option_name,
                status: o.status ?? 1,
              })),
            });
          } else {
            // Ensure options from menuData are included
            const existingIds = new Set(existing.options.map(o => o.variant_option_id));
            mdVar.options.forEach(o => {
              if (!existingIds.has(o.variant_option_id)) {
                existing.options.push({
                  variant_option_id: o.variant_option_id,
                  option_name: o.option_name,
                  status: o.status ?? 1,
                });
              }
            });
          }
        });
      }

      const mergedVariants = Array.from(groupedMap.values());
      console.log("Edit product variant results (merged)", mergedVariants);
      setVariantOptionsResult(mergedVariants);

      // The selectedOptions should already be initialized from menuData
      console.log("Current selectedOptions from menuData:", selectedOptions);
    } catch (error) {
      console.error("Error processing edit variants:", error);
      // Fallback to menuData variants on error
      if (menuData?.variantData) {
        setVariantOptionsResult(menuData.variantData);
      }
    }
  }

  // Helper function to group variant options by variant_id and variant_name
  function groupVariantOptions(flatOptions) {
    const variantMap = new Map();

    flatOptions.forEach((option) => {
      const key = option.variant_id;
      
      if (!variantMap.has(key)) {
        variantMap.set(key, {
          variant_id: option.variant_id,
          variant_name: option.variant_name,
          title: option.variant_name, // For compatibility with menuData structure
          options: [],
        });
      }

      const variant = variantMap.get(key);
      variant.options.push({
        variant_option_id: option.variant_option_id,
        option_name: option.option_name,
        status: option.status,
      });
    });

    return Array.from(variantMap.values());
  }

  async function fetchVariantOptions(variantId) {
    const response = await fetch(
      `${BASE_URL_TEST}/api/voptions/findByVariantId/${variantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: loginToken ? `Bearer ${loginToken}` : "",
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Error fetching data for variant_id: ${variantId}`);
    }
    const data = await response.json();
    console.log("varianoptinds data", data);
    return data.data;
  }

  // const removeImageFromForm = (imgid) => {
  //   console.log("imageid",imgid)

  //   setSelectedImageIds(prev =>
  //     prev.includes(imgid)
  //       ? prev.filter(id => id !== imgid)
  //       : [...prev, imgid]
  //   );
  //   console.log("formValuesimages",selectedImageIds)
  // };

  // const removeImageFromForm = (imgid) => {
  //   console.log("Checkbox clicked imgid",imgid,selectedImageIds)
  //   setSelectedImageIds((prev) => {
  //     const updated = prev.includes(imgid)
  //       ? prev.filter(id => id !== imgid)
  //       : [...prev, imgid];

  //     setFormValues((prevForm) => ({
  //       ...prevForm,
  //       image_ids: updated,
  //     }));
  //     setSelectedImageIds(updated)

  //     console.log("✅ Updated image_ids:", updated);

  //     return updated;
  //   });
  // };

  useEffect(() => {
  console.log("formValues changed", formValues);
}, [formValues]);


  const removeImageFromForm = (imgid) => {
    console.log("Checkbox clicked imgid", imgid, selectedImageIds);
    if (!isEditing) {
      // setSelectedImageIds((prev) => {
      //   const updated = prev.includes(imgid)
      //     ? prev.filter((id) => id !== imgid)
      //     : [...prev, imgid];

      //   setFormValues((prevForm) => ({
      //     ...prevForm,
      //     image_ids: updated,
      //   }));
      //   setSelectedImageIds(updated);

      //   console.log("✅ Updated image_ids:", updated);

      //   return updated;
      // });

      setSelectedImageIds((prev) => {
        if (prev.includes(imgid)) {
          const updated = prev.filter((id) => id !== imgid);
          setFormValues((prevForm) => ({
            ...prevForm,
            image_ids: updated,
          }));
          return updated;
        }

        const totalCount = prev.length + selectedFiles.length;
        if (totalCount >= 3) {
          setImagesError(true);
          alert("You can select only 3 images total.");
          return prev;
        } else {
          setImagesError(false);
        }

        const updated = [...prev, imgid];
        setFormValues((prevForm) => ({
          ...prevForm,
          image_ids: updated,
        }));

        return updated;
      });
    } else if (isEditing) {
      const deleteUrl = urls("deleteVProductsImageById", imgid);
      setDeletinImageId(imgid);
      fetchDeleteImageData(deleteUrl);
    }
  };

  // console.log("formValuesimages",formValues.images)

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  const handleDiscountChange = (value) => {
    console.log("value", value);
    // if(value){
    const discount = parseFloat(value);

    setFormValues({
      ...formValues,
      discount: value,
    });

    // if (/^\d*$/.test(value)) {

    // setDiscountError("")
    // }
    // else{
    //   setDiscountError("Please enter only number")
    // }

    console.log("discount", discount);
    if (!isNaN(discount) && discount >= 0) {
      const salePrice =
        formValues.salePrice - (formValues.salePrice * discount) / 100;
      console.log("salePrice after discount", salePrice);

      setFormValues({
        ...formValues,
        discount: value,
        salePrice: salePrice,
      });
    } else {
      // When discount is cleared or invalid, restore original price
      setFormValues({
        ...formValues,
        discount: "",
        salePrice: formValues.salePrice,
      });
    }

    // }
    // else{

    // }
  };

  return (
    <>
      <Box sx={{ mt: 3, borderRadius: "12px" }}>
        <SnackbarComponent
          open={snackbarState.open}
          onClose={handleSnackbarClose}
          severity={snackbarState.severity}
          message={snackbarState.message}
          position={snackbarState.position}
        />
        <Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <StyledPaper sx={{ flex: 1 }}>
              <Box sx={{}}></Box>
              <IconButton
                sx={closeIconStyle}
                onClick={() => {
                  setFormValues(getInitialFormValues());
                  setModalOpen(false);
                  setCustomProduct(false)
                }}
              >
                <CloseIcon />
              </IconButton>
              <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                {/* Category */}
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography variant="h6" gutterBottom>
                    Select category
                  </Typography>
                  <FormControl fullWidth sx={{ mb: 2 }} size="small">
                    <InputLabel>Select a seller</InputLabel>
                    <Select
                      name="category"
                      disabled={isEditing ? true : false}
                      error={!!categoryNameError}
                      helperText={
                        categoryNameError && (
                          <Typography
                            sx={{
                              textAlign: "left",
                              marginTop: 1,
                              color: "red",
                            }}
                          >
                            {categoryNameError}
                          </Typography>
                        )
                      }
                      value={formValues.category_id}
                      // onChange={(e) => {
                      //   setFormValues({
                      //     ...formValues,
                      //     category_id: e.target.value,
                      //   });
                      // }}
                      onChange={(e) => {
  setFormValues(prev => ({
    ...prev,
    category_id: e.target.value,
  }));
}}

                      label="Select a seller"
                      sx={{
                        width: "280px",
                      }}
                    >
                      {vendorCategoryNames &&
                        Array.isArray(vendorCategoryNames) &&
                        vendorCategoryNames.map((item, index) => (
                          <MenuItem value={item.category_id}>
                            {item.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Box>

                {/* Sub-category */}
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography variant="h6" gutterBottom>
                    Select sub-category
                  </Typography>
                  <FormControl fullWidth sx={{ mb: 2 }} size="small">
                    <InputLabel>Physical Product</InputLabel>
                    <Select
                      name="subCategory"
                      disabled={isEditing ? true : false}
                      error={!!subCategoryNameError}
                      value={formValues.sub_cat_id}
                      // onChange={(e) => {
                      //   setFormValues({
                      //     ...formValues,
                      //     sub_cat_id: e.target.value,
                      //   });
                      // }}
                      onChange={(e) => {
  setFormValues(prev => ({
    ...prev,
    sub_cat_id: e.target.value,
  }));
}}

                      label="Physical Product"
                      sx={{
                        width: "280px",
                      }}
                    >
                      {subCategoryNames && subCategoryNames.length > 0 ? (
                        subCategoryNames.map((item) => (
                          <MenuItem value={item.sub_cat_id}>
                            {item.name}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="no_prod"></MenuItem>
                      )}

                      {/* <MenuItem value="Digital">Digital Product</MenuItem> */}
                    </Select>
                  </FormControl>
                </Box>
              </Box>

              <Box sx={{}}>
                {/* style for above sx=display: 'flex', gap: 2 */}
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Name
                  </Typography>
                  {/* <Autocomplete
                    freeSolo
                    options={productNames}
                    value={formValues.product_name}
                    onInputChange={(event, newValue) => {
                      setFormValues({ ...formValues, product_name: newValue });
                      setSelectedProduct(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        variant="outlined"
                        size="small"
                        placeholder="Product Name"
                        sx={{ mb: 2 }}
                      />
                    )}
                  /> */}

                  {/* <Autocomplete
                    freeSolo
                    options={!isEditing ? productNames : []}
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : option.name
                    }
                    isOptionEqualToValue={(option, value) =>
                      typeof value === "string"
                        ? option.name === value
                        : option.product_id === value.product_id
                    }
                    value={
                      !isEditing
                        ? productNames.find(
                            (p) => p.product_id === formValues.product_id
                          ) || null
                        : formValues.product_name
                    }
                    onInputChange={(event, newInputValue) => {
                      console.log("event", event, newInputValue,"pdi",formValues.product_id);
                      setFormValues({
                        ...formValues,
                       
                        product_name: newInputValue,
                      });
                    }}
                    onChange={(event, newValue) => {
                      if (newValue && typeof newValue !== "string") {
                        setFormValues({
                          ...formValues,
                          product_id: newValue.product_id,
                          product_name: newValue.name,
                        });
                      } else {
                        setFormValues({
                          ...formValues,
                          product_id: "",
                          product_name: newValue || "",
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        // error={error}
                        error={!!productNameError}
                        helperText={
                          productNameError ? "Product Name is required" : ""
                        }
                        color="red"
                        variant="outlined"
                        size="small"
                        placeholder="Product Name"
                        sx={{ mb: 2 }}
                      />
                    )}
                  /> */}
                  {/* <Autocomplete
                    freeSolo
                    options={!isEditing ? productNames : []}
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : option.name
                    }
                    isOptionEqualToValue={(option, value) =>
                      typeof value === "string"
                        ? option.name === value
                        : option.product_id === value.product_id
                    }
                    value={
                      !isEditing
                        ? 
                      formValues.product_id
                        ? productNames.find(
                            (p) => p.product_id === formValues.product_id
                          ) || ""
                        : formValues.product_name || "" : menuData['product_name']
                    }
                    onInputChange={(event, newInputValue) => {
                      console.log("inpuchange",formValues['product_id']);
                      setFormValues((prev) => ({
                        ...prev,
                        product_name: newInputValue,
                       
                        product_id: prev.product_id,
                      }));
                    }}
                    onChange={(event, newValue) => {
                      if (newValue && typeof newValue !== "string") {
                        // User selected from dropdown
                        setFormValues({
                          ...formValues,
                          product_id: newValue.product_id,
                          product_name: newValue.name,
                        });
                      } else {
                        // User cleared the input
                        // setFormValues({
                        //   ...formValues,
                        //   product_id: "",
                        //   product_name: newValue || "",
                        // });

                           if (!newValue) {
      setFormValues({
        ...formValues,
        product_id: "",                
        product_name: "",
      });
    }
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        error={!!productNameError}
                        helperText={
                          productNameError ? "Product Name is required" : ""
                        }
                        value={formValues.product_name}
                        variant="outlined"
                        size="small"
                        placeholder="Product Name"
                        sx={{ mb: 2 }}
                      />
                    )}
                  /> */}
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
  {isCustom ? (
    <TextField
      fullWidth
      placeholder="Enter product name"
      value={formValues.product_name}
      onChange={(e) =>
        setFormValues(prev => ({
          ...prev,
          product_name: e.target.value,
        }))
      }
    />
  ) : (
    isEditing ? (
      <TextField
        fullWidth
        placeholder="Enter product name"
        value={formValues.product_name}
        onChange={(e) =>
          setFormValues(prev => ({
            ...prev,
            product_name: e.target.value,
          }))
        }
      />
    ) : (
      <>
        {mode === "select" ? (
          <FormControl fullWidth>
            <Select
              value={formValues.product_id || ""}
              displayEmpty
              onChange={(e) => {
                const selectedId = e.target.value;
                const selectedItem = productNames.find(
                  (p) => p.product_id === selectedId
                );
                if (selectedItem) {
                  setFormValues(prev => ({
                    ...prev, // keep category / subcategory
                    product_id: selectedItem.product_id,
                    product_name: selectedItem.name,
                  }));
                }
              }}
            >
              <MenuItem disabled value="">
                <em>Select product</em>
              </MenuItem>
              {productNames.map((item) => (
                <MenuItem key={item.product_id} value={item.product_id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <TextField
            fullWidth
            placeholder="Enter product name"
            value={formValues.product_name}
            onChange={(e) =>
              setFormValues(prev => ({
                ...prev,
                product_name: e.target.value, // keep same ID
              }))
            }
          />
        )}
        {mode === "select" && !!formValues.product_id && (
          <IconButton
            onClick={() => {
              setMode("input"); // Switch to input mode
              // KEEP ID and category/subcategory
              setFormValues(prev => ({ ...prev }));
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </>
    )
  )}
</Box>




                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Product Description (20 Words)
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!productDescError}
                    helperText={
                      productDescError ? "Product Description is required (max 20 words or 200 characters)" : ""
                    }
                    placeholder="Product description"
                    value={formValues.product_description}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                       const words = inputValue.trim().split(/\s+/).filter(Boolean);
                      const wordCount = words.length;
                      const charCount = inputValue.length;
                    if (wordCount > 20 || charCount > 200) {
                             setproductDescError(true);
                            return; // Do NOT update state, prevents extra typing
                    }
                      if (words.length <= 20) {
                        setFormValues({
                          ...formValues,
                          product_description: e.target.value,
                        });
                        setproductDescError(false);
                      }else{
                        setproductDescError(true);
                      }
                    }}
                    sx={{ mb: 2 }}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Tags (These tags help you in search result)
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="#fashion, #electronics, #home"
                   // error={!!tagsError}
                   // helperText={tagsError ? "Product Tags is required" : ""}
                    value={formValues.tags}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        tags: e.target.value,
                      })
                    }
                    sx={{ mb: 2 }}
                    
                  />
                </Box>
              </Box>

              <Box sx={{}}>
                {/* style for above sx=display: 'flex', gap: 2 */}
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    SKU
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formValues.sku}
                    error={!!skuError}
                    helperText={skuError ? "Product SKU is required" : ""}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        sku: e.target.value,
                      })
                    }
                    sx={{ mb: 2 }}
                    placeholder="TSH-BLU-M (Tshirt Blue Medium)"
                  />
                </Box>
              </Box>

              {renderVariantOptions()}
              {/* <Box sx={{ fontWeight: "bold" }}>
                <Typography variant="h6">Product varient</Typography>
                <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Weight
                  </Typography>
                  <FormControl fullWidth sx={{ mb: 2 }} size="small">
                    <InputLabel>Size</InputLabel>
                    <Select
                      name="published"
                      value={formValues.published}
                      onChange={handleInputChange}
                      label="Published"
                    >
                      <MenuItem value="50">50</MenuItem>
                      <MenuItem value="60">60</MenuItem>
                      <MenuItem value="65">65</MenuItem>
                      <MenuItem value="70">70</MenuItem>
                      <MenuItem value="80">80</MenuItem>
                    </Select>
                  </FormControl>
                  <Typography variant="h6" gutterBottom>
                    Size
                  </Typography>
                  <FormControl fullWidth sx={{ mb: 2 }} size="small">
                    <InputLabel>Size</InputLabel>
                    <Select
                      name="published"
                      value={formValues.published}
                      onChange={handleInputChange}
                      label="Published"
                    >
                      <MenuItem value="Small">Small</MenuItem>
                      <MenuItem value="Medium">Medium</MenuItem>
                      <MenuItem value="Large">Large</MenuItem>
                      <MenuItem value="XL">XL</MenuItem>
                      <MenuItem value="XXL">XXL</MenuItem>
                    </Select>
                  </FormControl>

                  <Typography variant="h6" gutterBottom>
                    Color
                  </Typography>
                  <FormControl fullWidth sx={{ mb: 2 }} size="small">
                    <InputLabel>Color</InputLabel>
                    <Select
                      name="featured"
                      value={formValues.featured}
                      onChange={handleInputChange}
                      label="Featured"
                    >
                      <MenuItem value="White">White</MenuItem>
                      <MenuItem value="Black">Black</MenuItem>
                      <MenuItem value="Green">Green</MenuItem>
                      <MenuItem value="Red">Red</MenuItem>
                      <MenuItem value="Orange">Orange</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Box> */}

              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Regular price
                  </Typography>
                  {/* <Autocomplete
                    freeSolo
                    options={regularPrices}
                    value={formValues.regularPrice}
                    onInputChange={(event, newValue) =>
                      setFormValues({ ...formValues, regularPrice: newValue })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        variant="outlined"
                        size="small"
                        placeholder="Enter Regular Price"
                        sx={{ mb: 2 }}
                      />
                    )}
                  /> */}
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    inputMode="numeric"
                    error={!!regularPriceError}
                    helperText={
                      regularPriceError && (
                        <Typography
                          sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                        >
                          {regularPriceError}
                        </Typography>
                      )
                    }
                    inputProps={{ inputMode: "numeric", maxLength: 5 }}
                    value={
                      formValues.regularPrice ? formValues.regularPrice : ""
                    }
                    onChange={(e) => {
                      const input = e.target.value;
                      setFormValues({
                          ...formValues,
                          regularPrice: e.target.value,
                        });
                        setRegularPriceError("");
                    }}
                    sx={{ mb: 2 }}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Sale price
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    inputMode="numeric"
                    error={!!salePriceError}
                    helperText={
                      salePriceError && (
                        <Typography
                          sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                        >
                          {salePriceError}
                        </Typography>
                      )
                    }
                    value={formValues.salePrice}
                    onChange={(e) => {
                      const input = e.target.value;
                      setFormValues({
                        ...formValues,
                        salePrice: e.target.value,
                      });
                      // if (/^\d*$/.test(input)) {

                      // setSalePriceError("")
                      // }
                      // else{
                      //   setSalePriceError("Please enter only number")
                      // }
                    }}
                    sx={{ mb: 2 }}
                  />
                </Box>
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Discount (1-99%) only           
                         </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!discountError}
                    helperText={
                      discountError && (
                        <Typography
                          sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                        >
                          {discountError}
                        </Typography>
                      )
                    }
                    value={formValues.discount}
                    onChange={(e) => {
                    //  handleDiscountChange(e.target.value);
                        setFormValues({
      ...formValues,
      discount: e.target.value,
    });
                    }}
                    InputProps={{
                      endAdornment: <Typography sx={{ ml: 1 }}>%</Typography>,
                    }}
                    sx={{ mb: 2 }}
                    inputProps={{ inputMode: "numeric", maxLength: 2 }}
                  />
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Stock Quantity
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formValues.stock_quantity}
                    error={!!stockQuantityError}
                    helperText={
                      stockQuantityError && (
                        <Typography
                          sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                        >
                          {stockQuantityError}
                        </Typography>
                      )
                    }
                    inputProps={{ inputMode: "numeric", maxLength: 5 }}
                    onChange={(e) => {
                      const input = e.target.value;
                    //  if (/^\d*$/.test(input)) {
                        setFormValues({
                          ...formValues,
                          stock_quantity: e.target.value,
                        });
                        setStockQuantityError("");
                      //} 
                      // else {
                      //   setStockQuantityError("Please enter only number");
                      // }
                    }}
                    sx={{ mb: 2 }}
                  />
                </Box>
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Badge
                  </Typography>
                  <FormControl fullWidth sx={{ mb: 2 }} size="small">
                    <InputLabel>Select Badge</InputLabel>
                    <Select
                      name="badge"
                      value={formValues.badge_id}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selectedItem = badge.find(
                          (item) => item.badge_id === selectedId
                        );

                        setFormValues({
                          ...formValues,
                          badge_id: selectedId,
                          badge_name: selectedItem?.name || "",
                        });
                      }}
                      label="Physical Product"
                      sx={{
                        width: "280px",
                      }}
                    >
                      {badge && badge.length > 0 ? (
                        badge.map((item) => (
                          <MenuItem value={item.badge_id}>{item.name}</MenuItem>
                        ))
                      ) : (
                        <MenuItem value="no_prod"></MenuItem>
                      )}

                      {/* <MenuItem value="Digital">Digital Product</MenuItem> */}
                    </Select>
                  </FormControl>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Ribbon
                  </Typography>
                  <FormControl fullWidth sx={{ mb: 2 }} size="small">
                    <InputLabel>Select Ribbon</InputLabel>
                    <Select
                      name="ribbon"
                      value={formValues.ribbon_id}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selectedItem = ribbon.find(
                          (item) => item.badge_id === selectedId
                        );

                        setFormValues({
                          ...formValues,
                          ribbon_id: selectedId,
                          ribbon_name: selectedItem?.name || "",
                        });
                      }}
                      label="Physical Product"
                      sx={{
                        width: "280px",
                      }}
                    >
                      {ribbon && ribbon.length > 0 ? (
                        ribbon.map((item) => (
                          <MenuItem key={item.badge_id} value={item.badge_id}>
                            {item.name}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="no_prod"></MenuItem>
                      )}

                      {/* <MenuItem value="Digital">Digital Product</MenuItem> */}
                    </Select>
                  </FormControl>
                </Box>
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Brand
                  </Typography>
                  <FormControl fullWidth sx={{ mb: 2 }} size="small">
                    <InputLabel>Select Brand</InputLabel>
                    <Select
                      name="brand"
                      value={formValues.brand_id}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selectedItem = brands.find(
                          (item) => item.brand_id === selectedId
                        );

                        setFormValues({
                          ...formValues,
                          brand_id: selectedId,
                          brand_name: selectedItem?.name || "",
                        });
                      }}
                      label="Physical Product"
                      sx={{
                        width: "280px",
                      }}
                    >
                      {brands && brands.length > 0 ? (
                        brands.map((item) => (
                          <MenuItem key={item.brand_id} value={item.brand_id}>
                            {item.name}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="no_prod"></MenuItem>
                      )}

                      {/* <MenuItem value="Digital">Digital Product</MenuItem> */}
                    </Select>
                  </FormControl>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Threshold Limit
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formValues.trashould_quantity}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        trashould_quantity: e.target.value,
                      })
                    }
                    sx={{ mb: 2 }}
                  />
                </Box>
              </Box>

              <Box sx={{ flexGrow: 1, padding: 3 }}>
                <Grid container spacing={3}>
                  {/* Self-Delivery */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Typography>Self-delivery</Typography>
                      <FormControlLabel
                        control={
                          <CustomSwitch
                            checked={formValues.self_delivery}
                            onChange={(e) => {
                              setSelfDelivery(e.target.checked);
                              setFormValues({
                                ...formValues,
                                self_delivery: e.target.checked ? 1 : 0,
                              });
                            }}
                          />
                        }
                        label={formValues.self_delivery ? "ON" : "OFF"}
                      />
                    </Box>
                    <Box>
                      {showSwitchError &&
                        !formValues.self_pickup &&
                        !formValues.self_delivery && (
                          <Typography color="red">
                            Please select either Self Pickup, Self Delivery, or
                            both.
                          </Typography>
                        )}
                    </Box>
                  </Grid>
                  {/* Self-Pickup */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Typography>Self-pickup</Typography>
                      <FormControlLabel
                        control={
                          <CustomSwitch
                            checked={formValues.self_pickup}
                            onChange={(e) => {
                              setSelfPickup(e.target.checked);
                              setFormValues({
                                ...formValues,
                                self_pickup: e.target.checked ? 1 : 0,
                              });
                            }}
                          />
                        }
                        label={formValues.self_pickup ? "ON" : "OFF"}
                      />
                    </Box>
                  </Grid>

                  {/* COD Allowed */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Typography>Is COD allowed?</Typography>
                      <FormControlLabel
                        control={
                          <CustomSwitch
                            checked={codAllowed}
                            onChange={(e) => {
                              setCodAllowed(e.target.checked);
                              setFormValues({
                                ...formValues,
                                cod_allowed: e.target.checked ? 1 : 0,
                              });
                            }}
                          />
                        }
                        label={codAllowed ? "ON" : "OFF"}
                      />
                    </Box>
                  </Grid>

                  {/* Is Returnable */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Typography>IS Returnable?</Typography>
                      <FormControlLabel
                        control={
                          <CustomSwitch
                            checked={isReturnable}
                            onChange={(e) => {
                              setIsReturnable(e.target.checked);
                              setFormValues({
                                ...formValues,
                                is_retuanable: e.target.checked ? 1 : 0,
                              });
                            }}
                          />
                        }
                        label={isReturnable ? "ON" : "OFF"}
                      />
                    </Box>
                  </Grid>

                  {/* Is Cancelable */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Typography>Is cancelable?</Typography>
                      <FormControlLabel
                        control={
                          <CustomSwitch
                            checked={isCancelable}
                            onChange={(e) => {
                              setIsCancelable(e.target.checked);
                              setFormValues({
                                ...formValues,
                                is_cancelable: e.target.checked ? 1 : 0,
                              });
                            }}
                          />
                        }
                        label={isCancelable ? "ON" : "OFF"}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              {isEditing ? (
                <FormControl fullWidth sx={{ mb: 5 }}>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={formValues.status || 0} // Default to 1 (Active)
                    onChange={(e) => {
                      console.log("select", e.target.value);
                      setFormValues((prev) => ({
                        ...formValues,
                        status: e.target.value,
                      }));
                    }}
                    label="Status"
                  >
                    <MenuItem value={1}>Active</MenuItem>
                    <MenuItem value={0}>Deactive</MenuItem>
                  </Select>
                </FormControl>
              ) : (
                ""
              )}

              <Box>
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography variant="h6" gutterBottom>
                      Description
                    </Typography>
                    <ReactQuill
                      theme="snow"
                      value={formValues.description}
                      onChange={(value) =>
                        setFormValues({ ...formValues, description: value })
                      }
                      modules={modules}
                      style={{ height: "200px" }}
                    />
                  </Box>
                </Grid>
              </Box>
              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 7 }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={handleClickrest}
                  style={{ padding: "10px 20px" }}
                >
                  Reset
                </Button>

                <Button
                  variant="contained"
                  color="success"
                  size="large"
                  onClick={() => handleClickproduct()}
                  style={{ padding: "10px 20px" }}
                >
                  {isEditing ? "Update Product" : " Add Product"}
                </Button>
              </Box>
            </StyledPaper>

            <Box sx={{ width: "35%" }}>
              <Box sx={{ mb: 4 }}>
                {selectedProduct && productImages[selectedProduct] && (
                  <Box sx={{ mt: 2 }}>
                    <img
                      src={productImages[selectedProduct]}
                      alt={selectedProduct}
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                )}
              </Box>
              <StyledPaper sx={{ mb: 2, textAlign: "center" }}>
                {/* {
                selectedFiles.length > 0 ? (
                  <img
                    src={URL.createObjectURL(selectedFiles[0])}
                    alt="Product"
                    style={{ width: "80%" }}
                  />
                ) : (
                  <img
                    src="/placeholder.jpg"
                    alt="Placeholder"
                    style={{ width: "80%" }}
                  />
                )} */}

                {selectedFiles.length > 0 && (
                  <Box
                    sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 2 }}
                  >
                    {selectedFiles.map((file, index) => (
                      <Box
                        key={index}
                        sx={{
                          position: "relative",
                          width: 100,
                          height: 100,
                          border: "1px solid #ddd",
                          borderRadius: "6px",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={URL.createObjectURL(file)}
                          alt="preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />

                        <Box
                          sx={{
                            position: "absolute",
                            top: 4,
                            right: 4,
                            background: "#ff4d4d",
                            color: "white",
                            width: 20,
                            height: 20,
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: "14px",
                          }}
                          onClick={() => handleRemoveImage(index)}
                        >
                          ×
                        </Box>
                      </Box>
                    ))}
                  </Box>
                )}
              </StyledPaper>

              <StyledPaper>
                <Typography variant="h6" gutterBottom>
                  Upload Images
                </Typography>
                <Box
                  sx={{
                    border: "2px dashed #ddd",
                    borderRadius: "4px",
                    p: 2,
                    textAlign: "center",
                    mb: 2,
                    cursor: "pointer",
                  }}
                  onClick={() => imageInputRef.current?.click()}
                >
                  <img
                    src="/ph_image-light.svg"
                    alt="Product"
                    style={{ width: "20%" }}
                  />
                  <Typography variant="body1" color="textSecondary">
                    Drop your image here, or browse
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    500 x 500 pixel less than 50kb
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Jpeg, png are allowed
                  </Typography>
                  <input
                    type="file"
                    accept="image/jpeg, image/png"
                    multiple
                    ref={imageInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {/* {selectedFiles.map((file, index) => (
              <ImageItem
                key={index}
                name={URL.createObjectURL(file)}
                error={file.type !== "image/jpeg" && file.type !== "image/png"}
                onRemove={() => {
                  setSelectedFiles((prevFiles) =>
                    prevFiles.filter((_, i) => i !== index)
                  );
                }}
              />
            ))} */}
                  {console.log("imagetye", formValues.images)}

                  {formValues && Array.isArray(formValues.images)
                    ? formValues.images.map((item) => (
                        <Box
                          key={item.p_image_id} // Use a unique key from your data if available
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            p: 1,
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                          }}
                        >
                          {isEditing ? 
                          (
                            <IconButton
                              sx={{ ml: 1, display: "flex" }}
                              onClick={() => {
                                removeImageFromForm(getImageId(item));
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                          ) : (
                            <Checkbox
                              defaultChecked 
                              onClick={() => {
                                //           if(isEditing)
                                //           {
                                //              removeImageFromForm(item.vp_image_id)
                                //           }
                                //           else{
                                //  removeImageFromForm(item.p_image_id)
                                //           }
                                removeImageFromForm(getImageId(item));
                              }}
                            />
                          )}

                          <img
                            src={item.image_url} // Use the dynamic image_url from your data
                            alt="Product thumbnail"
                            style={{
                              width: "50px",
                              height: "50px",
                              marginRight: "8px",
                              objectFit: "cover",
                            }}
                          />
                          <IconButton
                            sx={{ ml: 1, display: "none" }}
                            onClick={() => removeImageFromForm(item.p_image_id)}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Box>
                      ))
                    : null}
                </Box>

                {errorMessage && (
                  <Typography
                    variant="body2"
                    sx={{ mt: 2, color: "red", fontWeight: "bold" }}
                  >
                    {errorMessage}
                  </Typography>
                )}

                {imagesError ? (
                  <Typography
                    variant="body2"
                    sx={{ mt: 2, color: "red", fontWeight: "bold" }}
                  >
                    {imagesError ? "Please Select Only 3 images" : ""}
                  </Typography>
                ) : (
                  ""
                )}
              </StyledPaper>

              <Box
                sx={{ display: "none", justifyContent: "space-between", mt: 2 }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ width: "32%" }}
                  onClick={() => {}}
                >
                  UPDATE
                </Button>
                <Button variant="contained" color="error" sx={{ width: "32%" }}>
                  DELETE
                </Button>
                <Button
                  variant="contained"
                  color="inherit"
                  sx={{ width: "32%" }}
                  onClick={onBack}
                >
                  CANCEL
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Addbulkproducts;
